import React from 'react';
import { get } from '../../util/api';
import _ from 'lodash';
import { CopyToClipboard } from 'react-copy-to-clipboard';
// eslint-disable-next-line
import styled from 'styled-components/macro';
import { Box, Button, Switch, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import DirectionsIcon from '@mui/icons-material/Directions';
import moment from 'moment';

const RefreshBtn = (props) => {
	const [loading, setLoading] = React.useState(false);
	function onclick() {
		setLoading(true);
		fetch(props.link).then(() => {
			setLoading(false);
		});
	}

	return (
		<Button onClick={onclick} loading={loading}>
			<RefreshIcon />
		</Button>
	);
};

export default function Footprint() {
	const [loading, setLoading] = React.useState(true);
	const [data, setData] = React.useState({});
	const [onlyActives, setonlyActives] = React.useState(false);

	React.useEffect(() => {
		get('/maytapi/admin/phoneList?type=sandbox').then((temp) => {
			setLoading(false);
			let { phones, products } = temp;
			const map_pro = {},
				sub_pro = {};
			_.each(products, (it) => {
				map_pro[it.id] = it;
				if (it.sub)
					if (sub_pro[it.id]) sub_pro[it.id].push(it.sub);
					else sub_pro[it.id] = [it.sub];
			});
			setData({
				list: _.orderBy(
					_.map(_.filter(phones, { type: 'whatsapp' }), (it) => {
						it.product = map_pro[it.pid];
						it.sub = sub_pro[it.pid];
						it.subscription = it.product &&
							it.product.settings &&
							it.product.settings.subscription_package && [
								it.product.settings.subscription_package,
								it.product.settings.phone_limit,
								it.product.settings.agent_limit,
								it.product.settings.instagram_limit,
							];
						let token = (it.product && it.product.settings && it.product.settings.wapi_token) || temp.token;
						it.url = `https://api.maytapi.com/api/${it.pid}/${it.id}/screen?token=${token}`;
						it.backup_start = `https://api.maytapi.com/api/${it.pid}/${it.id}/backup_start?token=${token}`;
						it.purgeQueue = `https://api.maytapi.com/api/${it.pid}/${it.id}/purgeQueue?token=${token}`;
						it.token = token;
						it.copy_text = JSON.stringify(it, null, 2);
						return it;
					}),
					'id'
				),
			});
		});
	}, []);
	if (loading) return <Box attached="bottom">loading...</Box>;
	const { column, list, direction } = data;
	function handleSort(clickedColumn) {
		console.log('column', column, clickedColumn);
		console.log('list', list);
		if (clickedColumn === 'update_at') {
			if (column !== clickedColumn) {
				console.log('update_at');
				setData({
					column: clickedColumn,
					list: _.sortBy(list, (it) => {
						let unix = moment(it.updated_at).unix();
						console.log('unix', unix);
						return unix;
					}),
					direction: 'ascending',
				});

				return;
			}

			setData({
				column: clickedColumn,
				list: list.reverse(),
				direction: direction === 'ascending' ? 'descending' : 'ascending',
			});
		} else {
			if (column !== clickedColumn) {
				setData({
					column: clickedColumn,
					list: _.sortBy(list, [clickedColumn]),
					direction: 'ascending',
				});

				return;
			}

			setData({
				column: clickedColumn,
				list: list.reverse(),
				direction: direction === 'ascending' ? 'descending' : 'ascending',
			});
		}
	}
	let filteredlist = list;
	if (onlyActives) {
		filteredlist = _.filter(list, (it) => it.status === 'active');
	}
	/* if (onlyActives) {
		filteredlist = _.filter(list, (it) => it.subscription);
	}
	if (multiInstance) {
		filteredlist = _.filter(list, (it) => it.sessionId);
	} */

	const downloadCSV = () => {
		let newData = _.map(filteredlist, (it) => ({
			email: it.product.email,
			id: it.id,
		}));
		console.log('newData', newData);
		const header = ['email', 'id'];
		const csvData = newData.map((row) => header.map((field) => row[field]).join(','));
		console.log('csvData', csvData);
		const csv = [header.join(','), ...csvData].join('\n');
		const blob = new Blob([csv], { type: 'text/csv' });
		const url = window.URL.createObjectURL(blob);
		const a = document.createElement('a');
		a.href = url;
		a.download = 'data.csv';
		a.click();
	};
	return (
		<Box attached="bottom">
			<label>Only actives</label>
			<Switch toggle name="onlyActives" checked={onlyActives} onClick={() => setonlyActives(!onlyActives)} />
			<Button onClick={() => downloadCSV()}>Download csv</Button>
			{/* <label>Multi-Instance</label>
			<Switch toggle name="multiInstance" checked={multiInstance} onClick={() => setMultiInstance(!multiInstance)} /> */}

			<Table sortable celled>
				<TableHead>
					<TableRow>
						<TableCell>#</TableCell>
						<TableCell
							textAlign="center"
							style={{ width: 70 }}
							collapsing
							sorted={column === 'id' ? direction : null}
							onClick={() => handleSort('id')}
						>
							ID
						</TableCell>
						<TableCell sorted={column === 'pid' ? direction : null} onClick={() => handleSort('pid')}>
							Product
						</TableCell>
						<TableCell sorted={column === 'pid' ? direction : null} onClick={() => handleSort('pid')}>
							Host
						</TableCell>
						<TableCell sorted={column === 'subscription' ? direction : null} onClick={() => handleSort('subscription')}>
							Subscription
						</TableCell>
						<TableCell sorted={column === 'status' ? direction : null} onClick={() => handleSort('status')}>
							Status
						</TableCell>
						<TableCell>Number</TableCell>
						<TableCell sorted={column === 'update_at' ? direction : null} onClick={() => handleSort('update_at')}>
							Update Date
						</TableCell>
						<TableCell>Free Instance</TableCell>
						<TableCell>Purge Queue</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{console.log('filteredlist', filteredlist)}
					{_.map(filteredlist, (it, i) => {
						let { id, pid, product, number, auth, status, subscription, copy_text } = it;
						//console.log(subscription);
						return (
							<TableRow key={id}>
								<TableCell textAlign="center">{i + 1}</TableCell>
								<TableCell textAlign="center">
									<CopyToClipboard text={copy_text}>
										<span>
											{id}
											<a href={it.url} target="_blank" rel="noopener noreferrer">
												<DirectionsIcon />
											</a>
										</span>
									</CopyToClipboard>
								</TableCell>
								<TableCell>
									{product ? (
										<a href={'/yta/logs?uid=' + product.uid} target="_blank" rel="noopener noreferrer" id="weherere">
											{product.email}
										</a>
									) : (
										pid
									)}
								</TableCell>
								<TableCell>{product && product.product_type === 'live' ? 'dialogtab' : (product && product.product_type) || 'other'}</TableCell>
								<TableCell>
									{subscription && (
										<div>
											{subscription[0]} - [{'P:' + subscription[1] || 0},{'A:' + subscription[2] || 0},{'I:' + subscription[3] || 0}]
										</div>
									)}
								</TableCell>
								<TableCell>
									{status}
									{it.sessionId ? ` [${it.sessionId}]` : ''}
								</TableCell>
								<TableCell>{(number || auth) && `${number}, ${auth}`}</TableCell>
								<TableCell>{moment(it.updated_at).format('DD-MM-YYYY HH:mm')}</TableCell>
								<TableCell>{<RefreshBtn link={it.backup_start} />}</TableCell>
								<TableCell>{<RefreshBtn link={it.purgeQueue} />}</TableCell>
							</TableRow>
						);
					})}
				</TableBody>
			</Table>
		</Box>
	);
}
